import React from 'react';
import { Button } from '@insurancemenu/imenu-components-lib';
import { NoteAdd } from '@insurancemenu/imenu-components-lib/dist/icons';
import { PRODUCT_LINES_CONTENT_MAP } from '@insurancemenu/imenu-components-lib/dist/utils/ProductLinesHelper';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import { observer } from 'mobx-react-lite';
import { useRFQProductLineDelegate } from 'store/pages/rfq/rfq-response/proposal-rfq/rfqProductLineContext';
import { useRFQProposalPageType } from 'global/hooks/useRFQProposalPageType';
import CreatePortfolioModal from '../../../../common/proposal/CreatePortfolioModal';
import { createStyles } from './styles';
import useCreatePortfolioModalStore from './useCreatePortfolioModalStore';

interface Props {
  productLineId: ProductLineId;
}

interface ModalProps {
  productLineId: ProductLineId;
}

const RFQCreatePortfolioModal = observer(({ productLineId }: ModalProps) => {
  const store = useCreatePortfolioModalStore();
  return <CreatePortfolioModal productLineId={productLineId} store={store} createPortfolioCombinationType="RFQ" />;
});

const RFQCartItemProductLineHeader = observer(({ productLineId }: Props): JSX.Element => {
  const { canShowCreatePortfolioModal, createPortfolioModalDelegate } = useRFQProductLineDelegate();
  const pageType = useRFQProposalPageType();

  const productLineName = PRODUCT_LINES_CONTENT_MAP[productLineId].label;

  const classes = createStyles();
  return (
    <>
      <header className={classes.cartItemsHeader}>
        <div className={classes.titleWrapper}>
          <h3 className={classes.cartItemsTitle}>
            {PRODUCT_LINES_CONTENT_MAP[productLineId].icon('2.4rem')}
            <span className={classes.titleText}>{productLineName}</span>
          </h3>
          {pageType === 'CREATE_PORTFOLIO' && (
            <Button
              type="text"
              color="primary"
              leftIconProp={<NoteAdd />}
              onClick={createPortfolioModalDelegate.open}
              className={classes.actionButton}
              disabled={!canShowCreatePortfolioModal()}
            >
              Create Portfolio
            </Button>
          )}
        </div>
      </header>
      <RFQCreatePortfolioModal productLineId={productLineId} />
    </>
  );
});

export default RFQCartItemProductLineHeader;
